/**
 * Waitlist API Service
 * Calls the public raisy_BE waitlist endpoint (no auth — marketing form).
 *
 * project210 — THE REFERENCE MODULE for the generated client. It declares NO shape of its
 * own: both halves of its contract are published by the BE (`waitlist_manager.py` declares
 * `WaitlistJoinRequest` for the request and `ApiResponse` as the route's `response_model`),
 * so the types here come from `src/services/api/generated/`.
 *
 * Regenerate with `npm run generate:api`. That folder is never hand-edited — and it does
 * not need to be, because a change to the BE contract surfaces as a compile-time stop in
 * this file, naming the field.
 */

import { joinWaitlistApiV1WaitlistJoinPost } from "./generated/api/waitlist/waitlist";
import type { ApiRoutesWaitlistManagerApiResponse } from "./generated/models";

export async function joinWaitlist(
  name: string,
  email: string,
  code = "",
): Promise<ApiRoutesWaitlistManagerApiResponse> {
  // Public route: `anonymous` sends no Authorization header at all. The attachment itself
  // lives in exactly one place — `src/services/api/apiClient.ts`.
  return joinWaitlistApiV1WaitlistJoinPost(
    { name, email, code },
    { anonymous: true },
  );
}
